import React from 'react';
import { Dimensions, Text, View } from 'react-native';
import { AnimatedCard } from '../AnimatedCard';
import { ChartComponent } from '../ChartComponent';
import { SkeletonChart } from '../SkeletonLoader';
import { DashboardWidgetProps } from '../../config/dashboardWidgets/types';
import { styles } from '../../screens/HomeScreen/HomeScreen.styles';

const { width } = Dimensions.get('window');

const getChartScale = (): number => {
  if (width >= 1600) return 1.1;
  if (width >= 1280) return 0.95;
  return 0.8;
};

const getTitleFontSize = (): number => {
  if (width >= 1600) return 18;
  if (width >= 1280) return 16;
  return 15;
};

export const IssuerRankingNotionalWidget: React.FC<DashboardWidgetProps> = ({
  issuerDataNotional,
  issuerLoading,
  issuerError,
  notionalDisplayCurrency,
  onIssuerPress,
  hideLegendDetails = false,
}) => (
  <AnimatedCard
    style={[styles.card, styles.issuerCard]}
    animationType="slide"
    delay={100}
  >
    <View style={styles.sectionHeaderCustom}>
      <Text style={[styles.sectionTitleCustom, { fontSize: getTitleFontSize() }]}>
        Issuer Ranking by Notional
      </Text>
    </View>
    {issuerLoading && <SkeletonChart />}
    {!issuerLoading && !issuerError && issuerDataNotional.length > 0 && (
      <View style={styles.pieAndLegendRow}>
        <ChartComponent
          data={issuerDataNotional}
          chartType="pie"
          variant="embedded"
          scale={getChartScale()}
          showAllData={false}
          showAllInChart={true}
          maxItems={9}
          metric="notional"
          currencyCode={notionalDisplayCurrency}
          onIssuerPress={onIssuerPress}
          hideLegendDetails={hideLegendDetails}
        />
      </View>
    )}
  </AnimatedCard>
);

export const IssuerRankingProductsWidget: React.FC<DashboardWidgetProps> = ({
  issuerDataProducts,
  issuerLoading,
  issuerError,
  onIssuerPress,
  hideLegendDetails = false,
}) => (
  <AnimatedCard
    style={[styles.card, styles.issuerCard]}
    animationType="slide"
    delay={0}
  >
    <View style={styles.sectionHeaderCustom}>
      <Text style={[styles.sectionTitleCustom, { fontSize: getTitleFontSize() }]}>
        Issuer Ranking by Number of Products
      </Text>
    </View>
    {issuerLoading && <SkeletonChart />}
    {!issuerLoading && !issuerError && issuerDataProducts.length > 0 && (
      <View style={styles.pieAndLegendRow}>
        <ChartComponent
          data={issuerDataProducts}
          chartType="pie"
          variant="embedded"
          scale={getChartScale()}
          showAllData={false}
          showAllInChart={true}
          maxItems={9}
          metric="products"
          onIssuerPress={onIssuerPress}
          hideLegendDetails={hideLegendDetails}
        />
      </View>
    )}
  </AnimatedCard>
);
